import Vue from 'vue'

export const JustDigits = () => {
  Vue.directive('digitsonly', (el, binding) => {
    if (/[\d.]/i.test(el.value[el.value.length - 1])) {
      // to debug console.log('ok: ' + el.value)
    } else {
      let newValue = el.value.replace(/[^0-9.]/ig, '')
      el.value = newValue
      if (el.hasOwnProperty('_value')) {
        el._value = newValue
      }
      // to debug console.log('should fix: ' + el.value, newValue)
      binding.value = el.value
    }
  })
}


// WEBPACK FOOTER //
// ./src/filters/justdigits.js